import { defineStore } from "pinia";
import { consola } from "consola";
import type { Promotion } from "@/types/promotion";

export const usePromotionStore = defineStore("promotion", () => {
  const state = useState('promotionState', () => ({
    isLoading: false,
    promotions: [] as Promotion[]
  }));

  async function fetchPromotions() {
    state.value.isLoading = true;
    try {
      const { data } = await useFetch<Promotion[]>("/v2/promotions");

      const promotionsData = data.value as Promotion[];

      state.value.promotions = promotionsData.map((promotion) => {
        return {
          ...promotion,
          image: promotion.image.startsWith("http") ? promotion.image : `/storage${promotion.image}`
        };
      }) as Promotion[];

    } catch (error) {
      consola.error("/promotions", error);
    } finally {
      state.value.isLoading = false;
    }
  }

  return {
    state,
    fetchPromotions,
  };
});
